var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_839_187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.41718 15.1814L9.02018 20.7654C9.58818 20.7654 9.83418 20.5214 10.1292 20.2284L12.7922 17.6834L18.3102 21.7244C19.3222 22.2884 20.0352 21.9914 20.3082 20.7934L23.9302 3.82141L23.9312 3.82041C24.2522 2.32441 23.3902 1.73941 22.4042 2.10641L1.11418 10.2574C-0.338822 10.8214 -0.316822 11.6314 0.867178 11.9984L6.31018 13.6914L18.9532 5.78041C19.5482 5.38641 20.0892 5.60441 19.6442 5.99841L9.41718 15.1814Z",
    fill: "#039BE5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_839_187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTgIcon);
export default __webpack_public_path__ + "static/media/tg-icon.ff4bdd8595f9cd5f3b537b1758a6ba5a.svg";
export { ForwardRef as ReactComponent };